import { Component, OnInit,OnChanges,Input,Output,EventEmitter,NgZone } from '@angular/core';
declare var $;
declare var jslib;
@Component({
  selector: 'cookie-box',
  templateUrl: './cookiebox.component.html'
})
export class CookieBoxComponent implements OnInit
{
  public isShow;
  public msg = '';
  public url_info = '';
  constructor(
  ) {
    var _isshow = jslib.GetStorage('cookie');
    if(_isshow != false){
       this.isShow = true;
    }
  }
  ngOnInit() {
    if(this.isShow){
      this.msg = '為了給您更好的服務,本網站使用cookies,如果您繼續使用我們將視為您同意接收所有本網站的cookies。';
      this.url_info = 'https://officeportal.taiwantrade.com/cookies.html';
    }
  }
  Agree(){
    jslib.SetStorage('cookie',false);
    this.isShow = false;
    $('#top').css('bottom','2.5rem');
  }
}
